import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/wilmer/projects/wilmercantillo.com/src/components/md/index.tsx";
import { graphql } from 'gatsby';
import DynamicDate from './dynamic-date';
import { Badge, Link, Text } from '@chakra-ui/layout';
import { FaExternalLinkAlt } from 'react-icons/fa';
export const ProjectQuery = graphql`
  {
    site {
      siteMetadata {
        description
        title
      }
    }
    banner: file(
      relativePath: { eq: "project/global-track/images/banner.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      }
    }
  }
`;
export const _frontmatter = {};
const layoutProps = {
  ProjectQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1>{`Objetivos`}</h1>
    <p>{`Diseñar e implementar una solución para telemetría vehicular.`}</p>
    <ul>
      <li parentName="ul">{`Programar un modem GPS/GPRS para el envío de coordenadas geográficas
capturadas hacia un web server.`}</li>
      <li parentName="ul">{`Desarrollar de una página web para visualización de los datos enviados por el
modem GPS/GPRS.`}</li>
    </ul>
    <h1>{`Sobre el Proyecto`}</h1>
    <p>{`Este fue el proyecto a través del cual descubrí el mundo de la programación web,
ya que si bien venia programando durante los últimos 4 años desde 2015, siempre
fue programación orientada a análisis de datos y programación de bajo nivel.`}</p>
    <p>{`Realice este proyecto por primera vez durante el primer semestre de 2019 usando
el stack LAMP, y una vez finalizado dicho semestre lo volví construir con el
propósito de aprender un stack de tecnologías moderno como lo es MERN.`}</p>
    <h1>{`Construcción del proyecto`}</h1>
    <p>{`Este proyecto tuvo tres partes:`}</p>
    <ol>
      <li parentName="ol">{`Adquisición de trama GPS y envío a un web server`}</li>
      <li parentName="ol">{`Desarrollo de página web`}</li>
      <li parentName="ol">{`Integración con un sistema de adquisición de datos automático`}</li>
    </ol>
    <h3>{`Adquisición de trama GPS y envío a un web server`}</h3>
    <p>{`En esta fase del proyecto el objetivo fue enviar y capturar data de
geolocalización a/en un web server. Aquí exploramos por primera vez los
protocolos mas importantes detrás de la web, TCP y UDP, realizamos multiples
pruebas para seleccionar el protocolo que mejor solucionara las necesidades del
caso, para esto usamos wireshark para analizar los paquetes que se enviaban.
Hasta llegar a la conclusión de que el protocolo mas conveniente era UDP, ya que
nuestro caso admitía perdida de paquetes y la frecuencia de envíos seria alta.`}</p>
    <p>{`Después de tener el envió de paquetes resuelto creamos nuestro propio sniffer
para leer dichos paquetes y guardarlos en una base de datos, una RDS en AWS,
como podrán observar en el siguiente script en python.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/acf93f99e2148a99794d5e07d61baae4/9c1e6/sniffer.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "92%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAACuElEQVQ4y52Uy27aQBSGxwRfwSaAwTY4trn6EoNJgDRJlYRKIau+UV+gfYouu4ml9gX6Bu2ijbLsousoy0qJsU6PjYtyQ4mK9GuO8czn/5wzM4QIY0J4jSVEl9hNU8yVdZGIqkihSColG9cpfS8RSeNJ8rt694EYTfu95tu/Sb37k8i9S6rWvyQv1wXqF5G7nxBHJ0yKV70vJWsKhdY+0I0h4ASg6jYQFPVCIfACWVIC3Cg1g3PDnUM9eHtTtd8suMZwwZmTRb7hLxC+wAVL3Y1RyTvUbQb8hqxSAsyxqheKJjpsH0ScMQam4S2/WrNTt+u0nJN+JAF+XwE5PQiLndcgtsZRxZ2B6p9g6l4K5oxdENsTKJgBbCg2cFsBCOY4fc6gj4G06iLwEKTWNJIdHDt7CN95vm4J8KFDBYGkbIasMQXdfR0pXXSiOujG+b+UqxlQsF6B5s+iSjsAGaFc01stetJZffWxxynnFTtk9FFSn4jWd7FGI+C3Bjipd99V9vwA+nRTpN4xlLAphrsLBWMAlOJiY7Yhr3mQS2IcmeY2lsO953wNcBRWnBOouUeR5h1BuX8IYu8IpPYYXQ8hcV+0dqDcmwKr+6nTVQmeAtL1fljE/Sda0yinJq78FMTjYlZ1HqVM6veatSB3ge2kKZtbYQG3jeydRlVnBmX7GHR/H2q4hTjci88cwdQh9Q/YSIHGedJlefv0VnaOY807iFVnEtf647jaCWLJ9OOi4ceSNViO5iCNSyi+6UWCjlkpveXRExJgpfU53xjApn0C2nCGGxuPnx4Ab05A0AdYN0zf2sPOB8A2fYynIOAJYrBpJLtEMOUfKbCwdPiR1vybgjW5Knd2rhnNuSbVzjWR76i6Jpa7V6g/pNr+urptCM27JMec4U02R/6cUPQZ/vcSzQnNzbN4hCzmL6OTctXEF+t9AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Sniffer Python Script",
            "title": "Sniffer Python Script",
            "src": "/static/acf93f99e2148a99794d5e07d61baae4/c1b63/sniffer.png",
            "srcSet": ["/static/acf93f99e2148a99794d5e07d61baae4/5a46d/sniffer.png 300w", "/static/acf93f99e2148a99794d5e07d61baae4/0a47e/sniffer.png 600w", "/static/acf93f99e2148a99794d5e07d61baae4/c1b63/sniffer.png 1200w", "/static/acf93f99e2148a99794d5e07d61baae4/9c1e6/sniffer.png 1734w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <h3>{`Desarrollo de página web`}</h3>
    <p>{`Aprendimos de manera rápida y autodidacta los fundamentos del desarrollo web:
HTML, css y javascript básico. Fue de gran ayuda la metodología del profesor, el
cual nos indicaba el camino para que nosotros realizáramos la investigación y
practica por nuestra cuenta, de esta manera también desarrollamos un poco mas la
habilidad de aprender mucho mas eficientemente. Indagamos sobre como funciona el
internet y el protocolo HTTP, la estructura básica de una pagina web, como darle
estilo y como hacerla dinámica.`}</p>
    <p>{`La primera actividad que hice fue renderizar la fecha actual en una pagina web y
que esta se actualizara automáticamente.`}</p>
    <DynamicDate mdxType="DynamicDate" />
    <p>{`Este fue mi primer acercamiento con el DOM, las APIs del navegador y los
procesos asíncronos.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<div id="date"></div>
<script>
  setInterval(() => {
    document.getElementById('date').innerText = new Date().toString()
  }, 1000)
</script>
`}</code></pre>
    <p>{`Después de haber hecho un pequeño curso de javascript para familiarizarme con la
sintaxis y aprender algunos nuevos conceptos, y haber hecho algunos ejercicios
prácticos para desarrollar mi habilidad con html y css me dispuse a aprender
php, ya que a continuación debía sacar la data de geolocalización de la BD y
mostrarla en un mapa.`}</p>
    <p>{`Ya que ni mis compañeros de equipo ni yo contábamos con tarjeta de crédito en el
momento decidimos usar leaflet como alternativa a google maps ya que esta
primera es open source a diferencia de esta ultima.`}</p>
    <p>{`Este fue el resultado del landing de nuestra webapp.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/a781af4a57eca71197f12a4603fced6e/c2d13/landing.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "170.66666666666669%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAGoUlEQVRIx61W+U/URxT//gm2qSIgsLvAHuwuC8sC7i4sh0VEQaAWsdXSpFoieHCpaOtFPZpatUZr/cFqoom0iIqAiuKBggcgcqicIog1aFKoKBhNBT59b2BBkqb9xU0+O29m3nvzeW9m3nwlH30A/APDsCB0Fhbq/fFlUjIiI2IwzckDMjc13FxUMBmDEGCyQa/zh69hupDNgaGYHhBCCKV+MHy8p0Ov9YdUW1uHO3fuoLmpGWeKipGVmYVVq1Zj165d2L79eyxevASpKak4fjwf1dW3UVlZidu3a9Da2op79+6jqbEJVVXVOH26EOfOnoP08OFDdHZ2ovRiKTZt2oSzZ8+iubkZPT094Lnr16+LsfT0dFy4cEHoHjjwC1paWvDs2TO0t7ejra0Nt27dQn19PaSmpiYxsHnzZpSWlgpF7nd0dAiw/OjRI5w/fx7Z2dnCqKioCDt27BC6jY2NxPQeysrKUFNTA4kZnDlzBvv27RtbhVnwyvfvU0i0IDO7cuUK9u/fL9iyg0OHDiEnJwdHjx4VUdy9excNDQ2QKioqKD/HcfjwYTHIK7Ljq1evIj8/H8XFxSgoKBAM2Qkb86Ks7+Pjg9jYWCxfvhyXLl0ad1hSUoKsrKyx1ZnR5cuXRRgXL17EzZs3ce3aNezdu1eEyaFt27YNarUa8+fPR2RkJOLj48WGSbwaM9q5cyeSk5Nx48YNYcTguerqapSXl4tNYYZMgFkfPHgQRqMRer0eBoMBSUlJYk7icJkRGy5cuFBMLlu2DGvWrEFGRgYy0tKwgFj8Sg6aKKfMglPBDGUyGSZNmoTExESRtqqqKkj2PO3ZsweBgYFISUkRjlJTU7GU5A1bt6KENqSecltZewcllEuOqLCwUOiYzWZs2bJFbBrvgXTy5Enk5ubCYrEgJiZG5JMPel1dHRoIHefO4QmdgoYTJ1C8ezeKCk4LZ5xTPgG8eXxCmFR3dzek3N9yyVE0rFYLjuUeoxxep52sQG1tLbqaGtFFG9JI57M873eU0Xz11TI0tzSLM9rZ2YGnz56Ki8DE8vLyIMXHJcBdocKsyGh8vSQFmelrsHrVOjoKGVhBWLYiE8lLV2JpahpWpq/GN+s2YuP677A2ewPWf5uDjRtYXo8vFn2Fzz9LgqSQaaFRGeHh7g0XKgSTp7jBkQqD6zQVXJyVVBzUmPKRKyYTXEl2dvSAs5MnnBzd8eEHztR6UCHxhMxVDbmbBpKX2kgOfaEiKKbJoXGRQ+nkBiX1vXUBcHNVIiQkHKG2MCEb9IFwVxpgdHTFPJ03nGVK6DR+0BLYl8TOvIihTK7Bzz/8iGunTiEnaxUU7l5CwcHBBWHmIMwgODhME4YKhQZWfwsO7PwJem8/ik4nSKmVPpD4jzseHt6Ybg2BKcAMrbcRag0xV/thqpMcIVYbgiw2IWs1JtLVw03mQWx94eziTjfGONEhw1tNYbso4TpVBqWrCgYa05KSD7UquRoqmVrIIiJPA3QUkZ/aAK2cIhn1oREOSYEFE9GOoMkEMoySUUgKLQzEJIjGoqhyz6Yxm8xLLGKjKv8JIZqq92ydCWbKq2rUz1jIwbZI2EJmIcISjnCSrQSLORy28DmImhGNCJpjmUt/aFgUIiJjCXECYdQfC5mTrPMyYSYZxcyZh6ioeMyNSUA0tWxss36M4KAIBFsjEOAXBKOPBbE0z7qsM4venzBajH2wL4kfI4afr5UG/QRtzShrHp86RQ5HBzsU4swpaQM93fXwUOjovCrpvHrC7kfKylgLOzLolqSnUZVJG2nFeOY6wtpxsB7rpI8gMyObMO5Dwnv+SUNDQ7BjcHAQQ2/fCgwS3o5CjNvnh4cxRIaMQbYbHLdnSMOkwHj3N/xfFN68AQYGgNevx/VHfTAku7O3tPp5elMG6A2hhwTtFeUootqYT5X4yJEjgl3fi5fo7+hEP9XBAXqzXzzvw8CrV2OEJjhkg0Yq8X9TnQMrP36MTgLXOn64/njyBK30Rj/ofIT2ri600VPb9uABWlrbhO2YQ7vwfyF3dz9FFy3Q82cPent70ff8OXqo7e39a0Lo0rvx80rDlNjhoYmJtm8K499+E3L43o9Nf38/RjCAl5z0UdneDgyM4F09bvv6+kb1353rh8RXjr/34uMWYEbYbJjovvoTfA1mRND9Tvh0Ed3pMHE1TUar+BaMm5tI35BzqUbOGB0PGoPEd1JF9S2QPh7ZCVcMHnOXa6kQmGGlisN9O1g3mApGSPBM8RzwfbbfbcY/38olRNZB5TMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Landing primera version",
            "title": "Landing primera version",
            "src": "/static/a781af4a57eca71197f12a4603fced6e/c1b63/landing.png",
            "srcSet": ["/static/a781af4a57eca71197f12a4603fced6e/5a46d/landing.png 300w", "/static/a781af4a57eca71197f12a4603fced6e/0a47e/landing.png 600w", "/static/a781af4a57eca71197f12a4603fced6e/c1b63/landing.png 1200w", "/static/a781af4a57eca71197f12a4603fced6e/d61c2/landing.png 1800w", "/static/a781af4a57eca71197f12a4603fced6e/97a96/landing.png 2400w", "/static/a781af4a57eca71197f12a4603fced6e/c2d13/landing.png 2560w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Para la funcionalidad de ubicar un vehículo en tiempo real aprendimos a usar
Ajax y la importancia del manejo de procesos asíncronos en el comportamiento y
rendimiento de una aplicación.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f9230c0053623c6d69e415fd3aeb5e3c/d5682/real-time.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACRUlEQVQ4y31TW08aQRjlx4ggWOQi1yZQfWjTaNKbaWyf+sP61MSCQNvoYyMPfbO1Rq7LLuzO7oKYaiVU0hoKwuk3s6CEhG5y+C7MOfPt7Byb076CQDCBl6E4nizcw/arN9h6/hoO6rvdQbg4XKsUV61IcC8F4PVEEA4lEPDdpzxMPT9cTj9smqZD1000DROmymCaDUITrK6ClcoWyhJYkecVK9I6zjGNBgzi6boBxnQw0rLhf4+mAbIMnDaBapUgAaoKjEZzKbYR/dnr9aAoNXS7XfB6OBwKTrvXx2HrEp/1c+SMcxwQcuYFcmoLB/VT5OpW/MLOcP23LzYSEw4GA1y22+h0OiKf7N9oX+FTUcPOiYpUXkUyb8VUQUNyjPd5DR/LOv70B9aE/IdPNZp6jeE4l3/+wg4RPhAhU9KRJaQKDOkiEzkHz/cl805wWmgiPBGskWCSBDNjIhd+e6jg3VEdWb4J9XYJe9OC00KzgspYkE+SKd1NmSmx2zo9K8g/wCxubobWK1906PzqSNNZ7c4BP1d+hr97Ux9l3mNcXSMrNbBfa1lQLOzxWDu77efYDwwn14ZfSJ0Z4kJrGrMuKNW8V60znMgqjqUajsoyvnNUFFF/LVTwrSjhmOqiJAsu59i4XfzeKDY3XiAaWRO2WiZ7LTl8WIs/wtbTbQR9MXhcAayQ/Xxks83Hz/BwfQNRsh7ve8ieyxQ51yY8S0k4GCfhmBDivcUFj/BpJPRA1KJHcC56EYuuI0Gb8fV2Wuewe8drvPgHd/w8dR4AEjUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Tiempo real primera version",
            "title": "Tiempo real primera version",
            "src": "/static/f9230c0053623c6d69e415fd3aeb5e3c/c1b63/real-time.png",
            "srcSet": ["/static/f9230c0053623c6d69e415fd3aeb5e3c/5a46d/real-time.png 300w", "/static/f9230c0053623c6d69e415fd3aeb5e3c/0a47e/real-time.png 600w", "/static/f9230c0053623c6d69e415fd3aeb5e3c/c1b63/real-time.png 1200w", "/static/f9230c0053623c6d69e415fd3aeb5e3c/d61c2/real-time.png 1800w", "/static/f9230c0053623c6d69e415fd3aeb5e3c/d5682/real-time.png 2379w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`y consultar históricos.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/276e484a4f7c1ceae825b67d6a958aec/21de8/historical.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "67.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACTklEQVQ4y6WTS08TURTH52soogsEV/iI0ZK4wK9hWkBePhJWrihvFBPFaPwqrl26wRWiQCl9QJ/z7HSmtAPpY37eO6W1Tdh5k39mzut/zrnnXCUcmSW68Ia1yAybq+9YXFwj/GyayYk5JsKzV2IyMsfU5DzTUy+Zef6KF/MLzE6/JhKeQUEcy7bJqxqFYpFqtcr/HMX3fTzvHNOyKJVs6vU6Z9UaZacCwibtrluhVqvht9py2XHI5fNBcglpk3HSFlQoFTKoo2w2WzQazW5WQUNL6HuPV/OoVFwR5wYFBX4dQknUaDT+OXsepqg2Z5bJWw6uZuHZDtl8kWM1RaFUwKrqfQn8y4SK35O58+/YKrlMUtzrKdnTY7RUgpKhkU8n+LG7w7dfOyT0eODb8ltBXAdKhyhAW8DI/EY92SOT2mf/5w7pRBxVz2JbJvbJEd/3dtkrmJeEfrcQ+VF6q2sTgimqsUwN1zYwk3HSySzHsRiGfkjZzKIm/5ATPr1d9U25D3JIFVuQFsXkVXTRpl5MkjlNsH9wyFE6Ljo4wBW2vu46LcuJtlptNJvN4OuWTUp6DsPIomcS5BIxVC1OMiUI4zE0cSWOlg1alDGSowPl6vUUxA25DjY1sXP1qsfFxblYFYfKWRnHMahfXP0AlKXFdT5++Mz7rW2WoutdLEc3+LT9Vdi+tOWljQAry5uBbkv4r668JSqeam+cMjgwzMMHT7h/N8StwTvcuD6M1EmMhZ5ybzTEwLWhQJa2mwMjjD0eJ/RonOGhUaG7LWwj3Zi/w759O2DwQdkAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Historicos primera version",
            "title": "Historicos primera version",
            "src": "/static/276e484a4f7c1ceae825b67d6a958aec/c1b63/historical.png",
            "srcSet": ["/static/276e484a4f7c1ceae825b67d6a958aec/5a46d/historical.png 300w", "/static/276e484a4f7c1ceae825b67d6a958aec/0a47e/historical.png 600w", "/static/276e484a4f7c1ceae825b67d6a958aec/c1b63/historical.png 1200w", "/static/276e484a4f7c1ceae825b67d6a958aec/d61c2/historical.png 1800w", "/static/276e484a4f7c1ceae825b67d6a958aec/97a96/historical.png 2400w", "/static/276e484a4f7c1ceae825b67d6a958aec/21de8/historical.png 2436w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <h3>{`Integración con un sistema de adquisición de datos automático`}</h3>
    <p>{`Durante esta fase se realizo la programación del modem GPS, el cual fue el
dispositivo Syrus 3G, este dispositivo tiene una interfaz que permite conectarlo
al vehículo y obtener múltiples variables como velocidad, posición, entre otras.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1024px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/72b8626ae71304f89ed59d02dff784dc/2bef9/syrus.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC/UlEQVQ4y4WTyUsbcRzFvzOD0INFIRJyaYrRqKDilrjELe5Y951GpIpxiUtwt+ISJagoIohbFKGIlyr9C6qHnnpsU3rroYWeeumpl9ZM5tf3HajRUwPDDEO+n9/7vveG6D+/uro6Ki4upvLycuru7qaEhATFYrFQamqqxeFwvK6vrw+Mjo6a+vv7qbOzU3owvLa2Rr29vTQ0NERTU1NSbW2tApBSUVGh3/EXyWw2U2Ji4vO0tLT3eN+YlZVFY2Nj1N7eLrW2tkZge3t75PF4aHh4mGHy6ekp4XRdWWVlJdXU1FBMTAwre5mSkvK2urrakJ+fT0lJScrAwIDU1tZGd8DDw0OamJjQr+npaWVra4suLy8fA+gBbAXDLgC9eP5YUFDwDmtTZmYm2e32KJ4/Pz+nrq4uFkK0v79Pk5OTNDMzQ/Pz88rx8THd3NwYXC5X0Ol0itLSUv0qKSkRRUVFfP8O7/xY1Wqz2QgHSEaj8eGqy8vL5PP5lO3tbQoGgwb4+IlhGP6DQFSA/l23hYWFIjk5WcTHx/8sKyszcWAZGRmRMA4ODjgM+ezsjI6OjnQYFAisc5ubmyvgkwaQBrjGShFG2GQyhWHDr/X19Sd+v5+QcAS4uroqscpAIBA9Ozv7YW5uTkDtLbwUgGvNzc0a0hRQpkGJMBgMKh8Em7719PREs10jIyPS/arIJycnDLT19fWJhoYGdXx8XNvc3NTwXru4uNCurq4EgtKgTkMgqtfrFWiDn2sGATInfPdbWFiQd3Z2CAAHiitQThVphqAmlJ2drbIyDGiDg4Naenq6iuRZ+VeMRsFHrpPU0dERAUKytLi4yGAzFP7glTc2NnhtgXUFYCIvLy+M/oWgMJSTk8MefsFhbhSceyhjLgKEsQQVBJ8IVTAiwUYYvtLS0vIG989ut/s3e4hwBGoirFZrCAe8wlfk5Bm0Qb6+vo4Ad3d39W+1qqpK4l5xaZuammhpaYni4uIexcbGPgXgGQ5dgToflL7Asx3K9HlO+T7wL+8IOny98jNSAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Syrus 3g",
            "title": "Syrus 3g",
            "src": "/static/72b8626ae71304f89ed59d02dff784dc/2bef9/syrus.png",
            "srcSet": ["/static/72b8626ae71304f89ed59d02dff784dc/5a46d/syrus.png 300w", "/static/72b8626ae71304f89ed59d02dff784dc/0a47e/syrus.png 600w", "/static/72b8626ae71304f89ed59d02dff784dc/2bef9/syrus.png 1024w"],
            "sizes": "(max-width: 1024px) 100vw, 1024px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Una vez terminada la configuración habíamos completado todas las fases del
proyecto por lo que teníamos una primera versión funcional de la aplicación.`}</p>
    <h2>{`Segunda Versión`}</h2>
    <Link target="_blank" href="https://github.com/wildcant/TrackApp" mdxType="Link">
  <Badge variant="subtle" colorScheme="black" textTransform="capitalize" display="flex" alignItems="center" mdxType="Badge">
    <Text marginRight="0.4rem" mdxType="Text">
      Repositorio de la segunda versión del proyecto
    </Text>
    <FaExternalLinkAlt mdxType="FaExternalLinkAlt" />
  </Badge>
    </Link>
    <p>{`Como mencione anteriormente me plantee reconstruir el proyecto usando
tecnologías modernas para estar a la vanguardia ya que realmente me gusto mucho
proyecto y en general la programación enfocada a la web, para esta ocasión
decidí usar el stack MERN, por lo que me dispuse a aprender las principales
diferencias en bases de datos SQL y noSQL, con el objetivo de modelar los datos
de mi aplicación en mongo DB. Me plantee un panorama un poco mas realista en el
cual la aplicación tuviera autenticación de usuarios y cada usuario pudiera
administrar una flota de vehículos, y que la aplicación sirviera como plataforma
de rastreo para todos los vehículos de cada usuario. Este fue el resultado:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/284677e10e37cbdcbbf5399b6aa580fa/c2d13/track-app.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "54.666666666666664%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACfUlEQVQoz1WTWW/TQBRGLbW0ZGlJ0zi2E6eJG+924iRtGpLa7hYIBapKbALEJhAPgNgEb0hIPMKfPoxdQOLhaMaWdea7944l1w8wTQtV1Wg0dJp6iyuVDQrFco4sy+J9A01T0fUmtm2J77sCkyiK6HQ6GIZBs9lEritItWYbzQ5RnT7qtku5Wufs/A4fPn3hoyDciVmrb1PTXTYFSjugvuXna7MbIbd8NjSLYBQzX9xEancMjK5FZVNmU6RZWS1w/vA1n7/9EvxkkN6luj1D8w5RnJS6fYFsJTmqd8CVzlX82R2OTh8geZ5HEPi0WjpbrRbFYonLskehMWK13qNqTFDsGMXap/6HbK97MfbkkDCdM4ivY/RSCjVTJGy36fV6uK6b96JUKlM3rxIsXtPw0lyWSzKpoNqd4g8XPDp7gLuTYPZTvJEQj4/ZMiOkMAxxHIfKxkY+gIJIWG0P0fxjZHP/P9lfecNNGUyu4QxS+skcX4it4SGqESJlqTJpVrqu67lwUwi3RAmtvpA4F5Jad5YfIIu95ib44zl2FDM7OqM/PcWfnOBE44seZtRqNRRFoVxeww73mKU3iKYHGIMEY5jg7l1nO0xFulisCaPJMZZIGO6d4uwuOLp9n2cvniC5rpf3L7trmTQbihWMOZifM95f4I6O6ESJSHtIO8iEiRjIPv29E3qib51A3AB7xOLec959/IqUXdCsh1k69U/CnekJj56/4enLtzjDA8xeTLuXlTsTE57iiCHsxKfsxjfYTW4RCPHjV+/59v0H0vLyMktLS0iS9I9KpUJ5vcJqocSllQIrl4s5y6tFlsRzqbyOoqoCTQRRc7K/pLy2zm/CiEUNNFe6RQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Tiempo real version 2",
            "title": "Tiempo real version 2",
            "src": "/static/284677e10e37cbdcbbf5399b6aa580fa/c1b63/track-app.png",
            "srcSet": ["/static/284677e10e37cbdcbbf5399b6aa580fa/5a46d/track-app.png 300w", "/static/284677e10e37cbdcbbf5399b6aa580fa/0a47e/track-app.png 600w", "/static/284677e10e37cbdcbbf5399b6aa580fa/c1b63/track-app.png 1200w", "/static/284677e10e37cbdcbbf5399b6aa580fa/d61c2/track-app.png 1800w", "/static/284677e10e37cbdcbbf5399b6aa580fa/97a96/track-app.png 2400w", "/static/284677e10e37cbdcbbf5399b6aa580fa/c2d13/track-app.png 2560w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Mientras desarrollaba el frontend aprendí conceptos como separación de UI en
componentes, estado, proceso de renderizado y ciclo de vida.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f9eaffc371e761491fcb5a7e293dc69f/c2d13/track-select.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "54.666666666666664%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACVUlEQVQoz1WTW28SURSFKYm2XAqFchnnwtynUG4DHcEWhltFkAoxprZR2yYmxAcTtWqND9WH9lV/jD74+5b7zAi2Dyv7zDlzvr3X3jMBS1OgiQIyyQ1wJD6bQXwjiVA46imVTuMez4PjOAiCANM0oes6dMNApVqFLMtQFAU8naUzWQS0ow+w5lcwT79Cn18j1Zph9mSK808XOP/4GfWGi7RgQFAKENQCZLOMnF5CzihBy9uQ9CK4nIUavfdofIBAhl6wBwew+2MYjR5ivIrjkzkur3/i8uoH3NFzqCUXW/UBTLsHrezCrHa9tUHRqvXpvI294SEez44RSCcTcGo2KsVtqJKIRDyOlLQNTttBWrGhbO8SoAO93MZWrYfK7giW3YVRacOsuBR96aRN3iIg+W67HTiNJlRNRyKZgpx3UNgZEKDrwRhAyjcxnL7A719/0OxNKdGet8/OGZA5EI0KWc5ykBUVUk6GKOU8oGTVyUpvmX1RYdkZ4NnkiKx2lvsLoEUt4JSiD+RFiSYpQKB4E2hW3eWFRVSKe7dgi2TF+0NYJccHMhAviBD/AXPWDjW9C63U8i/fqNTX/zWzLRceYHBwjNOzVwhkCcisMiiLyc0UBKNGPdxHqfEQ+XqfYJ1bFTG4RpPVqDK25k0Ho6dnePv+gg0l41XHLLOYSG7CLO/i8OQNzr98wz5lZpP2+9mGTlXn6z047QnqrTEcd4Ki08fL1+9w+f0KgZWVFQSDwaXYcziyjuh63ItroQjuroZ9rYVxZzWESDSGLP05nrK+2NcSXY/hL4AQTeYBgwxpAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Tiempo real 2 version 2",
            "title": "Tiempo real 2 version 2",
            "src": "/static/f9eaffc371e761491fcb5a7e293dc69f/c1b63/track-select.png",
            "srcSet": ["/static/f9eaffc371e761491fcb5a7e293dc69f/5a46d/track-select.png 300w", "/static/f9eaffc371e761491fcb5a7e293dc69f/0a47e/track-select.png 600w", "/static/f9eaffc371e761491fcb5a7e293dc69f/c1b63/track-select.png 1200w", "/static/f9eaffc371e761491fcb5a7e293dc69f/d61c2/track-select.png 1800w", "/static/f9eaffc371e761491fcb5a7e293dc69f/97a96/track-select.png 2400w", "/static/f9eaffc371e761491fcb5a7e293dc69f/c2d13/track-select.png 2560w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Además, aprendí y use por primera vez el patrón MVC, y la importancia que tiene
la estructura de un proyecto tanto para backend como frontend.`}</p>
    <p>{`También decidí desarrollar una aplicación sencilla en react native que me
permitiera enviar la información de ubicación de un dispositivo para imitar el
proceso realizado por la Syrus`}</p>
    <h1>{`Conclusión`}</h1>
    <p>{`Este proyecto me permitió conocer el mundo de la programación web, y me mostro
el panorama de este interesante campo. Aborde una gran cantidad de tecnologías y
conceptos que me permitieron sentar las bases para luego construir mi carrera en
el mundo de desarrollo web. Por esta razón recomiendo realizar este tipo de
proyectos al momento de aprender, por mi experiencia puedo decir que es una
manera muy eficiente y rápida de aprender.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      